import { useEffect, useState } from "react";
import { useAppSelector } from "@/redux/hooks";
import { selectUser } from "@/redux/features/User/userSlice";
import IMenuItem from "@/interfaces/Props/IMenuItem";
import DirectionsBike from "@/assets/icon/DirectionsBike";
import Business from "@/assets/icon/Business";

const generatorCategoryAdminMenuRoutes = () => {

  const organizationChildren: Array<IMenuItem> = [];
  const inspectionChildren: Array<IMenuItem> = [];

  organizationChildren.push({
    id: "menu_organization_info",
    title: "MENU_ORGANIZATION_SUB_ORGANIZATION_TITLE",
    type: "item",
    tag: "normal",
    url: "/organizations"
  });

  organizationChildren.push({
    id: "menu_organization_questionnaire",
    title: "MENU_ORGANIZATION_SUB_QUESTIONNAIRE_TITLE",
    type: "item",
    tag: "normal",
    url: "/organizations/questionnaires"
  });

  inspectionChildren.push({
    id: "menu_inspection_user",
    title: "MENU_INSPECTION_SUB_INSPECTION_USER_TITLE",
    type: "item",
    tag: "normal",
    url: "/inspection/users"
  });

  inspectionChildren.push({
    id: "menu_inspection_tempwork",
    title: "MENU_INSPECTION_SUB_INSPECTION_TEMPWORK_ORGANIZATION_TITLE",
    type: "item",
    tag: "normal",
    url: "/inspection/tempworker/organization"
  });

  const menus: Array<IMenuItem> = [
    {
      id: "menu_organization",
      title: "MENU_ORGANIZATION_GROUP_TITLE",
      type: "group",
      tag: "normal",
      icon: <Business />,
      children: organizationChildren
    },
    {
      id: "menu_inspection",
      title: "MENU_INSPECTION_GROUP_TITLE",
      type: "group",
      tag: "normal",
      icon: <DirectionsBike />,
      children: inspectionChildren
    }
  ]
  return menus;
};

const generatorCategoryOrganizationMenuRoutes = () => {

  const organizationChildren: Array<IMenuItem> = [];


  // organizationChildren.push({
  //   id: "menu_organization_questionnaire",
  //   title: "MENU_ORGANIZATION_SUB_QUESTIONNAIRE_TITLE",
  //   type: "item",
  //   tag: "normal",
  //   url: "/organizations/questionnaires"
  // });



  const menus: Array<IMenuItem> = [
    {
      id: "menu_organization",
      title: "MENU_ORGANIZATION_SUB_QUESTIONNAIRE_TITLE",
      type: "item",
      tag: "normal",
      children: organizationChildren,
      url: "/organizations/questionnaires"
    }
  ]
  return menus;
};



const useDrawerMenu = () => {

  const user = useAppSelector(selectUser);


  const [menu, setMenu] = useState<Array<IMenuItem>>([]);

  useEffect(() => {
  }, [user.profile]);

  useEffect(() => {

    let tempMenu: Array<IMenuItem> = [];


    if (user.profile?.type === "admin") {
      const routes: Array<IMenuItem> = generatorCategoryAdminMenuRoutes();

      tempMenu.push(...routes);
    } else if (user.profile?.type === "organization") {
      const routes: Array<IMenuItem> = generatorCategoryOrganizationMenuRoutes();

      tempMenu.push(...routes);
    }

    setMenu(tempMenu);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.profile?.type]);
  return [menu];
};

export default useDrawerMenu;
